import {inject} from '@angular/core';
import {Router, CanActivateFn} from '@angular/router';
import {AuthService} from '@services/auth.service';
import {map} from 'rxjs/operators';

export const authCheckGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const publicRoutes = ['/login', '/callback', '/auth-error'];
  if (publicRoutes.some(publicRoute => state.url.startsWith(publicRoute))) {
    return true;
  }

  const isAuth = authService.isAuthenticated();

  if (isAuth) {
    return authService.hasApplicationAccess().pipe(map(allowed => {
      if (allowed) {
        return true;
      }
      if (allowed === null) {
        return router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url, error: 'access_check_unavailable' },
        });
      }
      authService.logout();
      return router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url, error: 'insufficient_permissions' },
      });
    }));
  }

  return router.createUrlTree(['/login'], {
    queryParams: {returnUrl: state.url}
  });
};
